import { FieldValue, fieldControlClass, fieldDescribedBy } from "./FieldValue";
import { TimeFieldProps } from "./TimeField.types";

// The control only reads "HH:mm", so seconds and an ISO date are trimmed off.
const toControlValue = (value: string | null | undefined) => {
  const match = /(\d{2}):(\d{2})/.exec(value ?? "");

  return match ? `${match[1]}:${match[2]}` : "";
};

/** Time-of-day editable field. */
export function TimeField({
  label,
  name,
  value,
  onChange,
  disabled,
  required,
  error,
  className,
  helpText,
}: TimeFieldProps) {
  return (
    <FieldValue label={label} htmlFor={name} required={required} helpText={helpText} error={error} className={className}>
      <input
        id={name}
        aria-describedby={fieldDescribedBy(name, helpText, error)}
        aria-invalid={error ? true : undefined}
        name={name}
        type="time"
        className={fieldControlClass("form-control", error)}
        value={toControlValue(value)}
        onChange={(event) => onChange(event.target.value)}
        disabled={disabled}
        required={required}
      />
    </FieldValue>
  );
}
